import { observable, action, computed, runInAction, decorate } from 'mobx';
import agent from '../api/agent';
import { RootStore } from './RootStore';
// import authContext from '../api/Auth';
// import adalConfig from '../../adalConfig';
export default class SelfTestStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
  }

  getSelfTestResults = async () => {
    var token = true//authContext.getCachedToken(adalConfig.clientId);
    if (token) {
      try {
        console.log("Performing self test.");
        const results = await agent.SelfTest.test();
        //console.log(results);
        return results;
      } catch (error) {
        throw error;
      }
    }
  }
}

decorate(SelfTestStore, {
    getSelfTestResults : action,
});
